import * as yup from 'yup';

export const initialStateForm = {
  email: '',
  password: '',
};

export const schemaLogin = yup
  .object({
    document: yup.string().required('Digite seu cpf'),
    password: yup
      .string()
      .required('Insira uma senha')
      .min(6, 'Digite ao menos 6 dígitos!'),
  })
  .required();

export const schemaRecover = yup
  .object({
    document: yup.string().required('Digite seu cpf'),
  })
  .required();

export const schemaSearch = yup
  .object({
    searchTxt: yup.string().notRequired(),
  })
  .required();

export const schemaRegister = yup
  .object({
    name: yup.string().required('Digite seu nome'),
    document: yup.string().required('Digite seu cpf'),
    cep: yup.string().required('Digite o cep'),
    address: yup.string().required('Digite o endereço'),
    email: yup
      .string()
      .required('Insira seu e-mail')
      .email('Insira um e-mail válido.'),
    password: yup
      .string()
      .required('Insira uma senha')
      .min(6, 'Digite ao menos 6 dígitos!'),
    confirmPassword: yup
      .string()
      .required('Confirme a senha')
      .min(6, 'Digite ao menos 6 dígitos!'),
    city: yup.string().required('Digite a cidade'),
    neighborhood: yup.string().required('Digite o bairro'),
    district: yup.string().required('Digite o estado'),
    birthDate: yup.string().required('Digite a data de nascimento'),
    numberAddress: yup.string(),
  })
  .required();

export const schemaProfile = yup
  .object({
    name: yup.string().required('Digite seu nome'),
    email: yup
      .string()
      .required('Insira seu e-mail')
      .email('Insira um e-mail válido.'),
  })
  .required();

export const schemaPassword = yup
  .object({
    password: yup
      .string()
      .required('Insira a senha atual')
      .min(6, 'Digite ao menos 6 dígitos!'),
    newPassword: yup
      .string()
      .required('Insira a nova senha')
      .min(6, 'Digite ao menos 6 dígitos!'),
  })
  .required();

export const schemaFinancial = yup
  .object({
    value: yup.string().required('Insira um valor para saque'),
  })
  .required();

export const schemaGavel = yup
  .object({
    qtd: yup.string().required('Insira a quantidade'),
    minValue: yup.string().notRequired(),
    idToken: yup.string().notRequired(),
    type: yup.string().notRequired(),
    valueUnity: yup.string().notRequired(),
    offersEndAt: yup.string().notRequired(),
  })
  .required();

export const schemaGavelBid = yup
  .object({
    value: yup.string().required('Insira o valor do lance'),
  })
  .required();
